import { render, staticRenderFns } from "./studentManagement.vue?vue&type=template&id=8cdb5eba&scoped=true&"
import script from "./studentManagement.vue?vue&type=script&lang=js&"
export * from "./studentManagement.vue?vue&type=script&lang=js&"
import style0 from "./studentManagement.vue?vue&type=style&index=0&id=8cdb5eba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cdb5eba",
  null
  
)

export default component.exports